import { render } from "./HomeSvg.vue?vue&type=template&id=eeb98084"
const script = {}
script.render = render

export default script